import React from 'react';
import { Button } from '@randajan/jet-react/dom/form';
import { PriceTag } from '../PriceTag/PriceTag';
import { QrPay } from '../QrPay/QrPay'

import "./Subscription.scss";


export const Subscription = (props)=>{
    const { pop } = props;

    return (
        <Button className="Subscription" onSubmit={_=>pop.up(<QrPay {...props}/>)}>
            <PriceTag {...props}/>
        </Button>
    )
}

